import { render, staticRenderFns } from "./ExtraResDialog.vue?vue&type=template&id=58410a6d"
import script from "./ExtraResDialog.vue?vue&type=script&lang=js"
export * from "./ExtraResDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtraResDialog.vue?vue&type=style&index=0&id=58410a6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports